export const CriminalJusticeAndLegalServices = {
  "label": "Criminal Justice And Legal Services",
  "value": [
    {
      "code": "BH-1800.1500-100",
      "keyword": "Domestic Violence Shelters"
    },
    {
      "code": "FT-1025",
      "keyword": "Civil Liberties Legal Assistance"
    },
    {
      "code": "FT-3600",
      "keyword": "Immigration\/Naturalization Legal Services"
    },
    {
      "code": "FV",
      "keyword": "Legal Services Organizations"
    },
    {
      "code": "FP-4000",
      "keyword": "Legal Counseling"
    },
    {
      "code": "FC",
      "keyword": "Courts"
    },
    {
      "code": "FC-8200.8100-900",
      "keyword": "Traffic Courts"
    },
    {
      "code": "FF-0500.1300",
      "keyword": "Community Service Work Programs"
    },
    {
      "code": "FF-0500.1300-200",
      "keyword": "Court Ordered Community Service Sites"
    },
    {
      "code": "FF-0500.1800",
      "keyword": "Diversion Programs"
    },
    {
      "code": "FF-0500.6500",
      "keyword": "Parole"
    },
    {
      "code": "FF-0500.6530-350",
      "keyword": "Juvenile Boot Camps"
    },
    {
      "code": "FF-0500.6550",
      "keyword": "Probation"
    },
    {
      "code": "FF-0500.9100-180",
      "keyword": "Domestic Violence Intervention Programs"
    },
    {
      "code": "FF-1500",
      "keyword": "Correctional Facilities"
    },
    {
      "code": "FF-1850",
      "keyword": "Ex-Offender Halfway Houses"
    },
    {
      "code": "FF-1900",
      "keyword": "Ex-Offender Reentry Programs"
    },
    {
      "code": "FF-3300.3500",
      "keyword": "Inmate Visitation Programs"
    },
    {
      "code": "FF-3300.6400",
      "keyword": "Prison Ministries"
    },
    {
      "code": "FJ-2600",
      "keyword": "Guardians ad Litem"
    },
    {
      "code": "FJ-6700.1800",
      "keyword": "District Attorney"
    },
    {
      "code": "FL-1000",
      "keyword": "Bureau of Alcohol Tobacco and Firearms"
    },
    {
      "code": "FL-2000",
      "keyword": "Federal Bureau of Investigation"
    },
    {
      "code": "FL-6500",
      "keyword": "Municipal Police"
    },
    {
      "code": "FL-8200",
      "keyword": "Sheriff"
    },
    {
      "code": "FL-8450",
      "keyword": "State Bureau of Investigation"
    },
    {
      "code": "FL-8500",
      "keyword": "State Police"
    },
    {
      "code": "FN-1500.1550",
      "keyword": "Community Crime Prevention Programs"
    },
    {
      "code": "FN-1500.1550-600",
      "keyword": "Neighborhood Watch Programs"
    },
    {
      "code": "FN-1500.1850",
      "keyword": "Dating Violence Prevention"
    },
    {
      "code": "FN-1500.1900-150",
      "keyword": "Child Abuse Prevention"
    },
    {
      "code": "FN-1500.1900-180",
      "keyword": "Elder Abuse Prevention"
    },
    {
      "code": "FN-1500.1900-250",
      "keyword": "General Abuse Prevention"
    },
    {
      "code": "FN-1500.2050",
      "keyword": "Fraud Prevention"
    },
    {
      "code": "FN-1500.2560",
      "keyword": "Human Trafficking Prevention"
    },
    {
      "code": "FN-1500.3600",
      "keyword": "Juvenile Delinquency Prevention"
    },
    {
      "code": "FN-1500.6250-800",
      "keyword": "Sex Offender Registries\/Community Notification"
    },
    {
      "code": "FN-1500.8100",
      "keyword": "Self Defense Training"
    },
    {
      "code": "FN-1500.8150",
      "keyword": "Sexual Assault Prevention"
    },
    {
      "code": "FN-1500.8960",
      "keyword": "Underage Drinking Prevention"
    },
    {
      "code": "FN-1700",
      "keyword": "Crime Reporting"
    },
    {
      "code": "FN-1700.1470-215",
      "keyword": "Fraudulent COVID-19 Test\/Vaccine\/Treatment Reporting"
    },
    {
      "code": "FN-1700.3025",
      "keyword": "Human Trafficking Reporting"
    },
    {
      "code": "FN-1700.3200",
      "keyword": "Identity Theft Reporting\/Recovery Programs"
    },
    {
      "code": "FN-1900",
      "keyword": "Crime Victim Support"
    },
    {
      "code": "FN-4000",
      "keyword": "Law Enforcement Community Engagement\/Outreach"
    },
    {
      "code": "FN-5000",
      "keyword": "Missing Persons Location Assistance"
    },
    {
      "code": "FP-0500",
      "keyword": "Advocacy"
    },
    {
      "code": "FT-1000.3300",
      "keyword": "Immigrant Benefits Assistance"
    },
    {
      "code": "FT-1000.9000",
      "keyword": "Veteran Benefits Assistance"
    },
    {
      "code": "FT-1020",
      "keyword": "Certificates\/Forms Assistance"
    },
    {
      "code": "FT-1800.1850",
      "keyword": "Employment Discrimination Assistance"
    },
    {
      "code": "FT-1800.3000",
      "keyword": "Housing Discrimination Assistance"
    },
    {
      "code": "FT-2450",
      "keyword": "Elder Law"
    },
    {
      "code": "FT-6900",
      "keyword": "Probate Assistance"
    },
    {
      "code": "FT-6940",
      "keyword": "Protective\/Restraining Orders"
    },
    {
      "code": "HH-0500.1500",
      "keyword": "Citizenship Education"
    },
    {
      "code": "ND-2050.9500",
      "keyword": "Workforce Reentry Programs"
    },
    {
      "code": "FN-1900",
      "keyword": "Crime Victim Support"
    },
    {
      "code": "RP-1500.1400-200",
      "keyword": "Domestic Violence Hotlines"
    },
    {
      "code": "JR",
      "keyword": "Public Safety"
    },
    {
      "code": "JR-6000",
      "keyword": "911 Services"
    },
    {
      "code": "TD-6600.2200-650",
      "keyword": "Office of the President of the United States"
    },
    {
      "code": "TD-6600.2200-900",
      "keyword": "United States House of Representatives Offices"
    },
    {
      "code": "TD-6600.2200-950",
      "keyword": "United States Senate Offices"
    },
    {
      "code": "TD-6600.4500-040",
      "keyword": "City\/Town Clerk Offices"
    },
    {
      "code": "TD-6600.4500-060",
      "keyword": "City\/Town Council Offices"
    },
    {
      "code": "TD-6600.4500-150",
      "keyword": "County Board of Supervisors Offices"
    },
    {
      "code": "TD-6600.4500-300",
      "keyword": "County Recorder Offices"
    },
    {
      "code": "TD-6600.4500-500",
      "keyword": "Mayors Offices"
    },
    {
      "code": "TD-6600.8000-300",
      "keyword": "Governor Offices"
    },
    {
      "code": "TD-6600.8000-450",
      "keyword": "Lieutenant Governor Offices"
    },
    {
      "code": "TD-6600.8000-800",
      "keyword": "State Legislature Offices"
    },
    {
      "code": "TE-1000.0700",
      "keyword": "Building Code Enforcement\/Appeals"
    }
  ]
}
